import type { OrderDeliveryMethod } from '../types/OrderDeliveryMethod';

export const OrderDeliveryMethods: { [K in OrderDeliveryMethod]: K } = {
    COURIER: 'COURIER',
    PICKUP_POINT: 'PICKUP_POINT',
    SELF_PICK_UP: 'SELF_PICK_UP',
};
